import React, { useState,useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from 'axios';

import { useRecoilState } from "recoil";
import { BranchMenus } from "../../components/recoil/atoms/Menus";

import HeaderBranchTitle from "../components/includes/HeaderBranchTitle";

import { ChangeMobileFormat,PassedMonthsCode, addThousandPoint,GetPaymentDate } from "../../components/common/Common";
import "../../css/style.css";

//결제내역
const PaymentCancel = () => {
  const { ph_idx } = useParams();

  const [varBranchMenus,setBranchMenus] = useRecoilState(BranchMenus);

  const [varPaymentInfo,setPaymentInfo] = useState({});

  //결제내역호출
  const GetPaymentInformation = async() => {
    const sendData = {ph_idx:ph_idx};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/branch_get_payment_canceled`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        //선택한 결제 정보
        setPaymentInfo(datas.payments[0]);
      }
    });
  }

  //최초실행부
  useEffect(() => {
    console.log(varBranchMenus);
    setBranchMenus({showMenu:true,gotoMain:1});
    GetPaymentInformation();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="vh-content">
      <HeaderBranchTitle varPageTitle={'결제 취소'}/>
      <div className="vh-content-body">
        <div className="payment-view-wrap">
          <div className="center-wrap">
            <div className="view-list">
              <div className="date-line">
                <div className="date">{GetPaymentDate(varPaymentInfo)}</div>
                <p className="price">₩ {addThousandPoint(varPaymentInfo.ph_price)} 원</p>
              </div>
              <div className="info-line">{varPaymentInfo.mem_name} {ChangeMobileFormat(varPaymentInfo.mem_mobile)} <span> 👼🏻[{varPaymentInfo.ch_name}({PassedMonthsCode(varPaymentInfo.ch_birthday)})]</span></div>
              <div className="flex">
                <p>결제 유형</p>
                <div>{varPaymentInfo.ph_method===1?"카드":"현금"}</div>
              </div>
              <div className="flex">
                <p>결제 학기</p>
                <div>{varPaymentInfo.sm_name}</div>
              </div>
              <div className="flex">
                <p>결제 클래스</p>
                <div>{varPaymentInfo.cl_name}</div>
              </div>
              <div className="flex">
                <p>청구서 ID</p>
                <div>{varPaymentInfo.ivc_id}</div>
              </div>
              <div className="flex">
                <p>결제 상태</p>
                <div className="pay-state02">결제취소</div>
              </div>									
            </div>
          </div>
        </div>
      </div>
    </div>	
  );
}
export default PaymentCancel;